export const TIMEOPTIONS = { hour: "2-digit", minute: "2-digit" }
export const DATEOPTIONS = {day: '2-digit', month: '2-digit', year: 'numeric'}
